// Version of the ac_portal application
export const VERSION = '1.3.0 23c01799';
